import {Page, PageRenderer} from '@/modules/report_server/domain/page'
import {PageGenerator} from '@/modules/report_server/domain/page_generator'
import {ContentProvider} from '@/modules/report_server/domain/content_provider'

import DynamicInvoiceViewerComponent from '@/modules/facturae/infra/pdf_view/DynamicInvoiceViewerComponent.vue'
import {nextTick} from '@/modules/report_server/infra/next_tick'
import { Invoiceable } from '../../domain/Invoiceable'
import { Configuration } from '../../domain/Configuration'

export class DynamicFacturaePage implements Page {
    renderer:PageRenderer|undefined
    id:string
    component:any
    visible=false;
    pageNum=0;
    showHeader:boolean=false;
    showLines:boolean=false;
    showLinesHeader:boolean=false;
    firstPrintedLine=-1
    lastPrintedLine=-1
    invoiceable: Invoiceable
    rectified_inv: Invoiceable|undefined
    configuration: Configuration
    templateCode: string
    options: string | null
    num_page: number = 0
    total_pages: number = 1
    page: any

    constructor(
        invoiceable:Invoiceable,
        configuration: Configuration,
        templateCode: string,
        templateOptions: string | null,
        rectified_inv?: Invoiceable
    ) {
        this.id='facturae-dynamic'
        this.invoiceable = invoiceable
        this.configuration = configuration
        this.rectified_inv = rectified_inv
        this.templateCode = templateCode
        this.options = templateOptions
        this.component = {...DynamicInvoiceViewerComponent}

        // The page object reference that will be passed as prop
        this.page = this
    }

    async setPageNum(pageNum: number): Promise<void> {
        return new Promise((resolve, reject) => {
            nextTick(() => {
                this.pageNum = pageNum
                this.id = this.pageNum.toString(10)
                resolve()
            })
        })

    }
    async setVisible(visible: boolean): Promise<void> {
        return new Promise((resolve, reject) => {
            nextTick(() => {
                this.visible = visible
                resolve()
            })
        })
    }
    setRenderer(renderer: PageRenderer): void {
        this.renderer = renderer
    }
}

export class DynamicFacturaePageGenerator implements PageGenerator {
    totalLines=0
    detailLines=0
    hasFooter=false
    invoiceable: Invoiceable
    rectified_inv: Invoiceable|undefined
    pages:DynamicFacturaePage[]=[]
    configuration:Configuration
    reservedEndLines:number
    templateCode: string
    templateOptions: string | null

    constructor(
        invoiceable: Invoiceable,
        configuration: Configuration,
        templateCode: string,
        templateOptions: string | null,
        rectified_inv?: Invoiceable
    ) {
        this.invoiceable = invoiceable
        this.configuration = configuration
        this.templateCode = templateCode
        this.templateOptions = templateOptions
        const computed_lines = invoiceable.get_lines_with_additional_descriptions()
        this.detailLines = computed_lines.length
        this.totalLines = this.detailLines + 1
        this.hasFooter = !!(this.configuration && this.configuration.footer)
        if (this.hasFooter) {
            this.totalLines++
        }
        // Reserva aún más espacio al final de la página para totales y footer
        this.reservedEndLines = this.hasFooter ? 10 : 8
        this.rectified_inv = rectified_inv
    }

    async getInitialPage(): Promise<Page> {
        const firstPage = new DynamicFacturaePage(
            this.invoiceable,
            this.configuration,
            this.templateCode,
            this.templateOptions,
            this.rectified_inv
        )
        firstPage.showHeader = true
        firstPage.showLines = true
        firstPage.showLinesHeader = true
        this.pages.push(firstPage)
        return firstPage
    }

    async getNextPage(page: Page): Promise<Page> {
        const actualPage = page as DynamicFacturaePage
        const newPage = new DynamicFacturaePage(
            this.invoiceable,
            this.configuration,
            this.templateCode,
            this.templateOptions,
            this.rectified_inv
        )

        newPage.firstPrintedLine = actualPage.lastPrintedLine
        newPage.lastPrintedLine = actualPage.lastPrintedLine // el primer grow añadirá la siguiente línea

        // Mostrar líneas mientras queden líneas de detalle por imprimir
        const hasMoreDetail = newPage.firstPrintedLine < (this.detailLines - 1)
        newPage.showLines = hasMoreDetail
        newPage.showLinesHeader = hasMoreDetail

        this.pages.push(newPage)
        return newPage
    }

    async canGrow(page: Page): Promise<boolean> {
        const facturaePage = page as DynamicFacturaePage;
        return facturaePage.lastPrintedLine < this.totalLines - 1
    }

    async grow(page: DynamicFacturaePage): Promise<void> {
        // grow the page
        const actualPage = page as DynamicFacturaePage;
        actualPage.lastPrintedLine++;
        return new Promise((resolve, reject) => {
            nextTick(() => {
                resolve()
            })
        })
    }

    async shrink(page: DynamicFacturaePage): Promise<void> {
        // shrink the page
        console.log('shrink called')
        const actualPage = page as DynamicFacturaePage;
        console.log(actualPage.lastPrintedLine)
        actualPage.lastPrintedLine--;
        return new Promise((resolve, reject) => {
            nextTick(() => {
                resolve()
            })
        })
    }
}

export class DynamicFacturaeProvider implements ContentProvider {
    invoiceable: Invoiceable
    configuration: Configuration
    rectified_inv: Invoiceable|undefined
    templateCode: string
    templateOptions: string | null

    constructor(
        invoiceable: Invoiceable,
        configuration: Configuration,
        rectified_inv: Invoiceable | undefined,
        templateCode: string,
        templateOptions: string | null
    ) {
        this.invoiceable = invoiceable
        this.configuration = configuration
        this.rectified_inv = rectified_inv
        this.templateCode = templateCode
        this.templateOptions = templateOptions
        console.log('got it', this.templateCode)
    }

    async getContent() {
        return [new DynamicFacturaePageGenerator(
            this.invoiceable,
            this.configuration,
            this.templateCode,
            this.templateOptions,
            this.rectified_inv
        )]
    }
}
